import tippy from 'tippy.js';
export const tooltip = (node, content) => {
    const instance = tippy(node, {
        content
    });
    return {
        destroy: instance.destroy
    };
};
export const tooltipRight = (node, content) => {
    const instance = tippy(node, {
        content,
        placement: 'right'
    });
    return {
        destroy: instance.destroy
    };
};
